<template>
  <div>
    <div class="top-navbar">
      <a href="javascript:closePage()" class="back-arrow">
        <i class="icon dripicons-chevron-left"></i>
      </a>
      {{ $t('result') }}
    </div>
    <div class="thefilter-container text-center active">
      <div class="container">
        <form id="form">
          <div class="filter-title">{{ $t('select_game') }}</div>
          <select class="form-control text-capitalize" @change="onChange($event)">
            <option value="300">{{$t('tables.300')}}</option>
            <option value="302">{{$t('tables.302')}}</option>
            <option value="303">{{$t('tables.303')}}</option>
            <option value="306">{{$t('tables.306')}}</option>
            <option value="301">{{$t('tables.301')}}</option>
            <option value="304">{{$t('tables.304')}}</option>
            <option value="305">{{$t('tables.305')}}</option>
            <option value="307">{{$t('tables.307')}}</option>
          </select>
        </form>
      </div>
    </div>
    <div class="container">
      <div style="clear: both;display: block;"></div>
      <AtomResult
        v-if="resultType === 'atom' "
        :data="data"
        :total="total"
      />
      <AtomWarResult
        v-else
        :data="data"
        :total="total"
      />
      <div style="display: flex; justify-content: center; margin-top: 10px;">
        <Pagination
          :page="currentPage"
          :total-page="totalPage"
          :handler-page="loadPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import AtomResult from '@components/content/atom-result.vue';
import AtomWarResult from '@components/content/atomwar-result.vue';
import Pagination from '@components/common/pagination.vue';
import { calculateScore } from '@handlers/atom/result.js';
import i18n from "@src/i18n";

const PAGE_SIZE = 20;

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    AtomResult, AtomWarResult, Pagination
  },
  data() {
    return {
      page: "",
      tableId: 300,
      currentPage: 1,
      data: null,
      howAreYouFeeling: null,
      resultType: 'atom',
    }
  },
  computed: {
    ...mapState('result', ['content', 'total']),
    totalPage: function(){
      // console.log('totalPage', this.total);
      let total = Math.floor(this.total / PAGE_SIZE);
      if(total > 20) {
        total = 20;
      }
      return total;
    },
  },
  watch: {
    content: function(newVal){
      this.data = newVal;
    },
  },
  mounted() {
    this.getData();
    const lang = this.$route.query.lang;
    if (lang !== undefined && lang !== "") {
      i18n.locale = lang;
    }
  },
  methods: {
    ...mapActions('result', ['getRoundsResultHistory']),
    getDataDetail: function(column){
      if(column.resultRaw === undefined){
        return {};
      }
      return calculateScore(column);
    },
    getData: function(e){
      const pages = Math.ceil(this.total/PAGE_SIZE);
      this.page = `Trang ${this.currentPage}/${pages}`;
      const limit = PAGE_SIZE;
      const page = this.currentPage - 1;
      const tableId = this.tableId;
      const params = { limit, page, tableId };
      this.getRoundsResultHistory(params);
    },
    previousPage(event, value) {
      if(this.currentPage > 1){
        this.currentPage -= 1;
        this.getData();
      }
    },
    nextPage(event, value) {
      const pages = Math.ceil(this.total/PAGE_SIZE);
      if(this.currentPage < pages){
        this.currentPage += 1;
        this.getData();
      }
    },
    firstPage(event, value) {
      this.currentPage = 1;
      this.getData();
    },
    lastPage(event, value) {
      this.currentPage = Math.ceil(this.total/PAGE_SIZE);
      this.getData();
    },
    onChange(event) {
      this.data = null;
      const tableId = event.target.value;
      this.tableId = tableId;
      this.getData();

      if(tableId === '301' ||
        tableId === '304' ||
        tableId === '305' ||
        tableId === '307'
      ) {
        this.resultType = 'atomwar';
      } else {
        this.resultType = 'atom';
      }
    },
    loadPage(event) {
      // console.log('loadPage', event);
      this.currentPage = event;
      this.getData();
    }
  },
  
}
</script>
